module.exports = __webpack_public_path__ + "img/noble2.9463ef86.png";